import { styled, TablePagination } from "@mui/material";

// `as typeof TablePagination` restores the polymorphic `component` prop that styled() erases from the type.
const AppPagination = styled(TablePagination)(() => ({
    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
        fontSize: 15,
        color: `#333`,
    },
})) as typeof TablePagination;

export default AppPagination;
